import { Component, input } from '@angular/core';

@Component({
  selector: 'td-wb-page-panel',
  template: '<ng-content />',
  styleUrls: ['page-panel.component.scss'],
  host: {
    '[class.td-wb-page-panel--touch-edge]': 'touchEdge()',
    '[class.td-wb-page-panel--touch-edge-reverse]': 'touchEdgeReverse()',
    '[class.td-wb-page-panel--top]': 'top()',
    '[class.td-wb-page-panel--bottom]': 'bottom()',
    '[class.td-wb-page-panel--left]': 'left()',
    '[class.td-wb-page-panel--right]': 'right()'
  }
})
export class PagePanelComponent {
  readonly top = input<boolean>(false);
  readonly bottom = input<boolean>(false);
  readonly left = input<boolean>(true);
  readonly right = input<boolean>(true);
  readonly touchEdge = input<boolean>(false);
  readonly touchEdgeReverse = input<boolean>(false);
}
